module.exports = __webpack_public_path__ + "img/material_en.c8b4b067.png";